
import { Component, Mixins } from 'vue-property-decorator';
import { UserLogsModule } from '~/store/modules/userLogs';
import PopupMixin from '~common-mixins/PopupMixin';
import SearchMixin from '~/mixins/search.mixin';
import { PopupModule } from '~common-store/modules/popup';
import { valueIncludesFilterValue } from '~/helpers';
import { humanReadableDate } from '~common-filters/humanReadableDate';
import { copyToClipboard } from '~common-helpers';

@Component({
    filters: {
        humanReadableDate,
    },
})
export default class UserLogsPopupBody extends Mixins(PopupMixin, SearchMixin) {
    page = 1;
    pageCount = 0;
    itemsPerPage = 10;
    headers = [
        { text: 'Action', value: 'action', align: 'left' },
        { text: 'Values', value: 'values' },
        { text: 'Date', value: 'date' },
    ];

    get logsDisplayed() {
        return UserLogsModule.logsDisplayed;
    }

    updateItemsPerPage(value: string) {
        const newValue = parseInt(value, 10);
        this.itemsPerPage = isNaN(newValue) ? 1 : newValue;
    }

    setFilterValue(id: string) {
        copyToClipboard(id);
        PopupModule.setFilterValue(id);
    }

    valueIncludesFilterValue(value: string) {
        if (PopupModule.filterValue) {
            return valueIncludesFilterValue(value);
        }
    }
}
